import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";





import { PrimaryUser } from "../../../../auth/types/models/User";

import UserFormSelect from "../../../../auth/components/user/UserForm/UserFormSelect";



import AddressFormSelect from "../../../../address/components/address/AddressForm/AddressFormSelect";



import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";













export const initialFormStateFn = () => { return {
    
        
        userId: null,
        
    
        
        addressId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.userId = PrimaryUser.fromQuery(location.state?.userId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        userId:
        string()
                .nanoid(msg`User is required`)
                .min(1, msg`User is required`),
    
    
        addressId:
        string()
                .nanoid(msg`Address is required`)
                .min(1, msg`Address is required`),
    
};

export const formSchema = object(formObject);

const UserAddressAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <UserFormSelect
        type="none"
        name="userId"
        label={t`User`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <AddressFormSelect
        type="embedded"
        name="addressId"
        label={t`Address`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
        </Container>
    )
}

export default UserAddressAddForm;
